import script from "./vendor-list.vue?vue&type=script&setup=true&lang=js"
export * from "./vendor-list.vue?vue&type=script&setup=true&lang=js"

import "./vendor-list.vue?vue&type=style&index=0&id=e2577faa&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e2577faa"]])

export default __exports__